import React from "react";
import { StyledCustomBtn, StyledSecondaryBtn } from "./CustomBtn.styles";
import { Gapper } from "../../ui/Gapper";

export const CustomBtn = ({
  text,
  onClick,
  Icon,
  noIcon = false,
  width,
  noMb,
  noMt,
  smallR,
  disabled = false,
  size = "md",
  variant = "contained",
  className,
  ...rest
}) => {
  return (
    <StyledCustomBtn
      type="submit"
      variant={variant}
      disabled={disabled}
      $noMt={noMt}
      $noMb={noMb}
      $btnWidth={width}
      $size={size}
      $disabled={disabled}
      onClick={onClick}
      className={className}
      {...rest}
    >
      <Gapper flexDirection="row" gap={8} alignItems="center">
        <p>{text}</p>
        {!noIcon && Icon && <Icon />}
      </Gapper>
    </StyledCustomBtn>
  );
};

export const SecondaryBtn = ({
  text,
  onClick,
  Icon,
  width,
  noMb,
  noMt,
  smallR,
  noIcon = false,
}) => {
  return (
    <StyledSecondaryBtn
      type="submit"
      variant="outlined"
      $noMt={noMt}
      $noMb={noMb}
      $btnWidth={width}
      onClick={onClick}
    >
      <Gapper flexDirection="row" gap={8}>
        <p>{text}</p>
        {!noIcon && Icon && <Icon />}
      </Gapper>
    </StyledSecondaryBtn>
  );
};
